import { Component, computed, inject, ChangeDetectionStrategy } from '@angular/core';
import { AcceleratorAreaService } from './accelerator-area.service';


@Component({
	selector: 'acc-loading-part',
	standalone: true,
	imports: [],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './acc-loading.part.html',
})
export class AccLoadingPart {
	
	public areaService = inject(AcceleratorAreaService);

	public message = computed(() => {
		const a = this.areaService.accNameStatus();
		if (a.status == 'Loading') return `Loading Accelerator ` + a.accName + `...`;
		if (a.status == 'Loaded') return `Loaded Accelerator ` + a.accName;
		if (a.status == 'Invalid') return `Invalid Accelerator Name: ` + a.accName;
		return `No AccName to load`;
	});

	public iconClass = computed(() => {
		const a = this.areaService.accNameStatus();
		if (a.status == 'Loading') return `fa-fw fa-regular fa-spin fa-spinner-third`;
		if (a.status == 'Loaded') return `fa-fw fa-regular fa-check`;
		if (a.status == 'Invalid') return `fa-fw color-red fa-solid fa-xmark`;
		return `fa-fw color-red fa-solid fa-xmark`;
	});
}